import script from "./PolicyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyPage.vue?vue&type=script&setup=true&lang=js"

import "./PolicyPage.vue?vue&type=style&index=0&id=25541353&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25541353"]])

export default __exports__